// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Liff from "./liff";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

var withLiff = Liff.withLiff;

var context = Liff.LiffContext;

function closeWindow(prim) {
  Liff.closeWindow();
  
}

function Liff$1(Props) {
  var options = Props.options;
  var app = Props.app;
  var loadingcompOpt = Props.loadingcomp;
  var loadingcomp = loadingcompOpt !== undefined ? Caml_option.valFromOption(loadingcompOpt) : undefined;
  return Curry._4(withLiff, options, app, loadingcomp, undefined);
}

var make = Liff$1;

export {
  withLiff ,
  context ,
  closeWindow ,
  make ,
  
}
/* withLiff Not a pure module */
